import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from '../../../../util/reactIntl';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { propTypes } from '../../../../util/types';
import { NotFoundPage, TopbarContainer } from '../../../index';
import {
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    Breadcrumb,
    Page,
    AccordionItems,
    HorseDealAppTeaser,
    HorseDealCreateAccountTeaser,
    ExternalLink,
    PopularDisciplines,
    LandingpageListingsParticipation,
    ListingCard,
    NamedLink,
    NamedRedirect,
} from '../../../../components';
import css from '../LandingPage.css';
import { redirectToURLWithModalState } from '../../../../components/Topbar/Topbar.helpers';
import MagnifyIcon from '../../../ListingPage/Icons/MagnifyIcon';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import config from '../../../../config';
import { ReviewsWidget } from '../../../AuthenticationPage/ReviewsWidget';
import { inArray } from 'sharp/lib/is';
import {
    cardRenderSizes,
    formatNumber,
    allowedCountries,
    noIndexTag,
    getMapUrl,
    getMapAltText,
    generateListingData,
    extractListingFromStore,
} from '../helpers';
import { capitalize } from '../../../../util/text';
import { loadWalkingParticipationData } from '../../SeoLandingPages.duck';
/** TODO: refactor dynamic pages */

const { listingTypeHorse } = config;

const pub_activities = 'Spazieren';

const SpazierbeteiligungFindenPageDynamicComponent = ({
    intl,
    location,
    history,
    currentUser,
    params,
}) => {
    const loc = useSelector(s => s.SeoLandingPages?.location);
    const error = useSelector(s => s.SeoLandingPages?.dynamicDataFetchError);
    const metadata = useSelector(s => s.SeoLandingPages?.metadata);
    const listings = useSelector(s => s.SeoLandingPages?.listings);
    const landingData = useSelector(s => s.SeoLandingPages?.landingData);
    const shouldNoIndex = useSelector(s => s.SeoLandingPages?.noListingsForLocation);
    const listOfLocations = useSelector(s => s.SeoLandingPages?.listOfLocations);
    const listingsParticipationData = useSelector(
        s => s.SeoLandingPages?.listingsParticipationData
    );

    const listings1to2 = useSelector(s => extractListingFromStore(s, '1-2', [pub_activities]));
    const listings2to3 = useSelector(s => extractListingFromStore(s, '2-3', [pub_activities]));
    const listings3to5 = useSelector(s => extractListingFromStore(s, '3-5', [pub_activities]));

    const [isMobile] = useIsMobile(1024);

    const { country: c, canton, city } = params;
    const { DE: countHorsesDE, CH: countHorsesCH } = metadata || {};

    const country = capitalize(c);
    const shouldFetchPerDayListings = country && !canton;

    const mapUrl = getMapUrl({ landingData, ...params });
    const altText = getMapAltText({ landingData, ...params });

    if (!inArray(country, allowedCountries) || error) {
        return <NotFoundPage />;
    }

    const generateListingContent = (listingData, daysArray) => {
        if (!listingData) return null;

        if (daysArray) {
            return daysArray.map((days, index) => {
                const daysPerWeekContentTitle = (
                    <FormattedMessage
                        id="SeoLandingPages.walkingShare.DaysPerWeekContent.Title"
                        values={{
                            chunk: (
                                <span className={css.pageTitleColor}>
                                    {intl.formatMessage(
                                        {
                                            id:
                                                'SeoLandingPages.walkingShare.DaysPerWeekContent.Title-chunk',
                                        },
                                        { days: days }
                                    )}
                                </span>
                            ),
                        }}
                    />
                );
                const daysPerWeekContentParagraph = intl.formatMessage(
                    { id: 'SeoLandingPages.walkingShare.DaysPerWeekContent.Paragraph' },
                    { days: days }
                );

                const isListingDataSet =
                    listingData[days] &&
                    listingData[days].listingData &&
                    listingData[days].listingData.length > 0;

                if (!isListingDataSet) return null;

                return (
                    <div key={index} className={css.listingSection}>
                        <h3>{daysPerWeekContentTitle}</h3>
                        <p>{daysPerWeekContentParagraph}</p>

                        <div className={css.listingCardsWrapper}>
                            {listingData[days].listingData.map(listing => (
                                <ListingCard
                                    className={css.listingCard}
                                    listing={listing}
                                    renderSizes={cardRenderSizes}
                                    maxParagraphHeight={89}
                                    key={listing.id.uuid}
                                />
                            ))}
                        </div>

                        <div className={css.listingFooter}>
                            <NamedLink
                                className={css.subLinkOutlined}
                                name="SearchPage"
                                to={{
                                    search: listingData[days].link,
                                }}
                            >
                                <FormattedMessage id={`SeoLandingPages.walkingShare.AllListings`} />
                            </NamedLink>
                        </div>
                    </div>
                );
            });
        } else {
            const isListingDataSet =
                listingData['listings'] &&
                listingData['listings'].listingData &&
                listingData['listings'].listingData.length > 0;
            const maxListings = city ? 6 : 9;

            return (
                <div className={css.listingSection}>
                    {isListingDataSet && (
                        <div className={css.listingCardsWrapper}>
                            {listingData['listings'].listingData
                                .slice(0, maxListings)
                                .map(listing => (
                                    <ListingCard
                                        className={css.listingCard}
                                        listing={listing}
                                        renderSizes={cardRenderSizes}
                                        maxParagraphHeight={89}
                                    />
                                ))}
                        </div>
                    )}

                    <div className={css.listingFooter}>
                        <NamedLink
                            className={css.subLinkOutlined}
                            name="SearchPage"
                            to={{
                                search: listingData['listings'].link,
                            }}
                        >
                            <FormattedMessage id={`SeoLandingPages.walkingShare.AllListings`} />
                        </NamedLink>
                    </div>
                </div>
            );
        }
    };

    /**
     * Dynamic text things
     */
    const breadcrumbPaths = [
        { label: intl.formatMessage({ id: 'SeoLandingPages.walkingShare.breadcrumb' }) },
    ];
    const locationType =
        country === 'Schweiz'
            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton' })
            : intl.formatMessage({ id: 'SeoLandingPages.locationType.federalState' });
    const locationTypeCountry =
        country === 'Schweiz'
            ? intl.formatMessage({
                  id: 'SeoLandingPages.locationType.country.heading1subText.switzerland',
              })
            : intl.formatMessage({
                  id: 'SeoLandingPages.locationType.country.heading1subText.germany',
              });
    const countryName =
        country === 'Schweiz'
            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.country.switzerland' })
            : intl.formatMessage({ id: 'SeoLandingPages.locationType.country.germany' });
    const wholeOf = intl.formatMessage({ id: 'SeoLandingPages.locationType.wholeOf' });
    const allOf = intl.formatMessage({ id: 'SeoLandingPages.locationType.allOf' });
    const cantonName = intl.formatMessage({ id: 'SeoLandingPages.locationType.canton.single' });
    const findPlacesNearbySubTitle = intl.formatMessage({
        id: 'SeoLandingPages.walkingShare.findPlacesNearby.SubTitle',
    });
    const findPlacesNearbyPlaceholder = intl.formatMessage({
        id: 'SeoLandingPages.findPlacesNearby.Placeholder',
    });

    let findPlacesNearbyTitle = '';
    let daysArray = null;
    let countHorses = 400;
    let metaTitle = '';
    let metaDescription = '';
    let headerSubtitleMoreOffers = '';
    let headerSubtitle = '';
    let headerSubtext = '';
    let heading1 = '';
    let heading1_subText = '';
    let heading2 = '';
    let heading2_subText = '';
    let listOfLocationsHeading = '';
    let listOfLocations_subText = '';
    let popularDisciplinesHeading = '';
    let popularDisciplinesSubText = '';
    let popularDisciplinesLocation = '';
    let listingsParticipationHeading = '';
    let listingsParticipationSubText = '';
    let listingsParticipationLinkPrefix = `/landing/spazierbeteiligung-finden/${country.toLowerCase()}`;
    let popularDisciplinesAddress = country;
    let boundaries = '50.530616,13.22464049,41.95508607,2.67776549';

    // breadcrumb
    if (country) breadcrumbPaths.push({ label: country });
    if (canton) breadcrumbPaths.push({ label: canton });
    if (city)
        breadcrumbPaths.push({
            label: `${landingData.postcode} ${landingData.name}`,
            urlPath: landingData.url_path,
        });

    if (country && !canton) {
        daysArray = ['1-2', '2-3', '3-5'];

        if (country === 'Schweiz') {
            countHorses = countHorsesCH;
        } else if (country === 'Deutschland') {
            countHorses = countHorsesDE;
        }

        metaTitle = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.metaTitle' },
            { locationType: countryName }
        );
        metaDescription = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.metaDescription' },
            { wholeOf: country === 'Schweiz' ? wholeOf : allOf, country: country }
        );

        heading1 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.country.heading1"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    locationTypeDer:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.der' }) + ' '
                            : '',
                    country: <span className={css.pageTitleColor}>{country}</span>,
                }}
            />
        );
        heading1_subText = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.country.heading1subText"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    number: formatNumber(countHorses),
                    country: countryName,
                    locationTypeCountry: locationTypeCountry,
                }}
            />
        );

        findPlacesNearbyTitle = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.country.findPlacesNearby.Title"
                values={{
                    locationTypeDer:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.der' }) + ' '
                            : '',
                    country: <span className={css.pageTitleColor}>{country}</span>,
                }}
            />
        );

        heading2 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.country.heading2"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    chunk: (
                        <span className={css.pageTitleColor}>
                            {intl.formatMessage({
                                id: 'SeoLandingPages.walkingShare.country.heading2-chunk',
                            })}
                        </span>
                    ),
                }}
            />
        );
        heading2_subText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.heading2subText' },
            {
                country: countryName,
            }
        );

        popularDisciplinesHeading = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.country.popularDisciplinesHeading"
                values={{
                    country: countryName,
                    chunk: (
                        <span className={css.pageTitleColor}>
                            {intl.formatMessage({
                                id: 'SeoLandingPages.walkingShare.popularDisciplinesHeading-chunk',
                            })}
                        </span>
                    ),
                }}
            />
        );
        popularDisciplinesSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.popularDisciplinesSubText' },
            {
                country: countryName,
            }
        );
        popularDisciplinesLocation = countryName;

        listingsParticipationHeading = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.listingsParticipationHeading' },
            {
                canton: (
                    <span className={css.pageTitleColor}>
                        {listingsParticipationData.count}{' '}
                        {country === 'Schweiz'
                            ? intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.canton.single.plural',
                              })
                            : intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.federalState.single.plural',
                              })}
                    </span>
                ),
            }
        );
        listingsParticipationSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.country.listingsParticipationSubText' },
            {
                cantons: locationTypeCountry.replace('in allen ', ''),
            }
        );

        headerSubtitleMoreOffers = intl.formatMessage(
            { id: 'SeoLandingPages.country.headerSubtitleMoreOffers' },
            { country: countryName }
        );

        headerSubtitle = intl.formatMessage({
            id: 'SeoLandingPages.locationType.country.headerSubtitle',
        });
        if (country === 'Schweiz') {
            headerSubtext = intl.formatMessage({
                id: 'SeoLandingPages.locationType.country.headerSubtext.switzerland',
            });
        } else if (country === 'Deutschland') {
            headerSubtext = intl.formatMessage({
                id: 'SeoLandingPages.locationType.country.headerSubtext.germany',
            });
            boundaries =
                '55.08149999602162%2C15.04189619759281%2C47.27011146235569%2C5.86634248758437';
        }
    } else if (canton && !city && landingData) {
        metaTitle = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.metaTitle' },
            {
                locationType: locationType,
                canton: landingData.name,
            }
        );
        metaDescription = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.metaDescription' },
            {
                locationType: locationType,
                canton: landingData.name,
            }
        );

        heading1 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.canton.heading1"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    in:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.im' })
                            : intl.formatMessage({ id: 'SeoLandingPages.locationType.in' }) + ' ',
                    location: (
                        <span className={css.pageTitleColor}>
                            {country === 'Schweiz' ? cantonName + ' ' : ''}
                            {landingData.name}
                        </span>
                    ),
                }}
            />
        );
        heading1_subText = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.canton.heading1subText"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    number: formatNumber(countHorses),
                    in:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton' })
                            : intl.formatMessage({ id: 'SeoLandingPages.locationType.in' }),
                    canton: landingData.name,
                }}
            />
        );

        findPlacesNearbyTitle = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.canton.findPlacesNearby.Title"
                values={{
                    in:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.im' })
                            : intl.formatMessage({ id: 'SeoLandingPages.locationType.in' }) + ' ',
                    location: (
                        <span className={css.pageTitleColor}>
                            {country === 'Schweiz' ? cantonName + ' ' : ''}
                            {landingData.name}
                        </span>
                    ),
                }}
            />
        );

        heading2 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.canton.heading2"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    canton: (
                        <span className={css.pageTitleColor}>
                            {country === 'Schweiz'
                                ? intl.formatMessage({
                                      id: 'SeoLandingPages.locationType.canton.single',
                                  })
                                : intl.formatMessage({
                                      id: 'SeoLandingPages.locationType.federalState.single',
                                  })}{' '}
                            {landingData.name}
                        </span>
                    ),
                }}
            />
        );
        heading2_subText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.heading2subText' },
            {
                canton:
                    (country === 'Schweiz'
                        ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton.single' })
                        : intl.formatMessage({
                              id: 'SeoLandingPages.locationType.federalState.single',
                          })) +
                    ' ' +
                    landingData.name,
            }
        );

        listOfLocationsHeading = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.listOfLocationsHeading"
                values={{
                    in: intl.formatMessage({ id: 'SeoLandingPages.locationType.im' }),
                    location: (
                        <span className={css.pageTitleColor}>
                            {country === 'Schweiz'
                                ? intl.formatMessage({
                                      id: 'SeoLandingPages.locationType.canton.single',
                                  })
                                : intl.formatMessage({
                                      id: 'SeoLandingPages.locationType.federalState.single',
                                  })}{' '}
                            {landingData.name}
                        </span>
                    ),
                }}
            />
        );
        listOfLocations_subText = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.listOfLocationsSubHeading"
                values={{
                    in:
                        country === 'Schweiz'
                            ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton' })
                            : intl.formatMessage({ id: 'SeoLandingPages.locationType.in' }),
                    location: landingData.name,
                }}
            />
        );

        popularDisciplinesHeading = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.canton.popularDisciplinesHeading"
                values={{
                    canton:
                        (country === 'Schweiz'
                            ? intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.canton.single',
                              })
                            : intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.federalState.single',
                              })) +
                        ' ' +
                        landingData.name,
                    chunk: (
                        <span className={css.pageTitleColor}>
                            {intl.formatMessage({
                                id: 'SeoLandingPages.walkingShare.popularDisciplinesHeading-chunk',
                            })}
                        </span>
                    ),
                }}
            />
        );
        popularDisciplinesSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.popularDisciplinesSubText' },
            {
                canton:
                    (country === 'Schweiz'
                        ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton.single' })
                        : intl.formatMessage({
                              id: 'SeoLandingPages.locationType.federalState.single',
                          })) +
                    ' ' +
                    landingData.name,
            }
        );
        popularDisciplinesLocation =
            (country === 'Schweiz'
                ? intl.formatMessage({ id: 'SeoLandingPages.locationType.canton' })
                : intl.formatMessage({ id: 'SeoLandingPages.locationType.federalState' })) +
            ' ' +
            landingData.name;

        listingsParticipationHeading = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.listingsParticipationHeading' },
            {
                canton: (
                    <span className={css.pageTitleColor}>
                        {listingsParticipationData.count}{' '}
                        {country === 'Schweiz'
                            ? intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.canton.single.plural',
                              })
                            : intl.formatMessage({
                                  id: 'SeoLandingPages.locationType.federalState.single.plural',
                              })}
                    </span>
                ),
            }
        );
        listingsParticipationSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.canton.listingsParticipationSubText' },
            {
                cantons: locationTypeCountry.replace('in allen ', ''),
            }
        );

        headerSubtitleMoreOffers = intl.formatMessage(
            { id: 'SeoLandingPages.canton.headerSubtitleMoreOffers' },
            {
                locationType: locationType,
                canton: landingData.name,
            }
        );
        headerSubtitle = intl.formatMessage(
            { id: 'SeoLandingPages.locationType.canton.headerSubtitle' },
            {
                aboutThis:
                    country === 'Schweiz'
                        ? intl.formatMessage({ id: 'SeoLandingPages.locationType.aboutThisCanton' })
                        : intl.formatMessage({
                              id: 'SeoLandingPages.locationType.aboutThisFederalState',
                          }),
            }
        );
        headerSubtext = (
            <>
                {landingData.description}
                {landingData.show_wiki_url && (
                    <a
                        className={css.wikipediaLink}
                        href={landingData.wiki_url}
                        rel="noopener noreferrer nofollow"
                    >
                        Wikipedia
                    </a>
                )}
            </>
        );

        popularDisciplinesAddress = `${landingData.name} ${country}`;
        boundaries = landingData.bounds;
    } else if (city && landingData) {
        metaTitle = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.city.metaTitle' },
            {
                postcode: landingData.postcode,
                city: landingData.name,
                canton: country === 'Schweiz' ? cantonName + ' ' : '',
                cantonName: landingData?.canton?.name,
                country: country,
            }
        );
        metaDescription = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.city.metaDescription' },
            { postcode: landingData.postcode, city: landingData.name }
        );

        heading1 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.heading1"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    location: (
                        <span className={css.pageTitleColor}>
                            {landingData.postcode} {landingData.name}
                        </span>
                    ),
                }}
            />
        );

        heading1_subText = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.heading1subText"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    city: landingData.name,
                }}
            />
        );

        findPlacesNearbyTitle = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.findPlacesNearby.Title"
                values={{
                    location: (
                        <span className={css.pageTitleColor}>
                            {landingData.postcode} {landingData.name}
                        </span>
                    ),
                }}
            />
        );

        heading2 = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.heading2"
                values={{
                    break: <br className={css.pageTitleBreak} />,
                    city: (
                        <span className={css.pageTitleColor}>
                            {landingData.postcode} {landingData.name}
                        </span>
                    ),
                }}
            />
        );
        heading2_subText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.city.heading2subText' },
            {
                city: landingData.name,
            }
        );

        popularDisciplinesHeading = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.popularDisciplinesHeading"
                values={{
                    city: landingData.name,
                    chunk: (
                        <span className={css.pageTitleColor}>
                            {intl.formatMessage({
                                id: 'SeoLandingPages.walkingShare.popularDisciplinesHeading-chunk',
                            })}
                        </span>
                    ),
                }}
            />
        );
        popularDisciplinesSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.city.popularDisciplinesSubText' },
            { city: landingData.name }
        );
        popularDisciplinesLocation = `${intl.formatMessage({
            id: 'SeoLandingPages.locationType.in',
        })} ${landingData.postcode} ${landingData.name}`;

        listingsParticipationHeading = (
            <FormattedMessage
                id="SeoLandingPages.walkingShare.city.listingsParticipationHeading"
                values={{
                    chunk: (
                        <span className={css.pageTitleColor}>
                            {intl.formatMessage({
                                id:
                                    'SeoLandingPages.walkingShare.city.listingsParticipationHeading-chunk',
                            })}
                        </span>
                    ),
                }}
            />
        );
        listingsParticipationSubText = intl.formatMessage(
            { id: 'SeoLandingPages.walkingShare.city.listingsParticipationSubText' },
            {
                city: landingData.name,
            }
        );
        headerSubtitleMoreOffers = intl.formatMessage(
            { id: 'SeoLandingPages.city.headerSubtitleMoreOffers' },
            { city: landingData.name }
        );
        headerSubtitle = intl.formatMessage({
            id: 'SeoLandingPages.locationType.city.headerSubtitle',
        });
        headerSubtext = (
            <>
                {landingData.description}
                {landingData.show_wiki_url && (
                    <ExternalLink className={css.wikipediaLink} href={landingData.wiki_url}>
                        Wikipedia
                    </ExternalLink>
                )}
            </>
        );

        popularDisciplinesAddress = `${landingData.postcode} ${landingData.name}`;
        boundaries = landingData.bounds;
    }

    const listingData = generateListingData({
        listings1to2,
        listings2to3,
        listings3to5,
        shouldFetchPerDayListings,
        address: popularDisciplinesAddress,
        bounds: boundaries,
        origin: loc,
        pubActivities: pub_activities,
        listings,
    });

    // prettier-ignore
    return (
        <Page
            title={metaTitle || '▷ Spazierbeteiligung finden - Tipps und Tricks für Pferdeliebhaber'}
            schema={{
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                description: metaDescription,
                name: metaTitle || '▷ Spazierbeteiligung finden - Tipps und Tricks für Pferdeliebhaber'
            }}
            metaTags={shouldNoIndex ? noIndexTag : null}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>

                <LayoutWrapperMain
                    className={css.staticPageWrapper}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <Breadcrumb
                        paths={breadcrumbPaths}
                        urlPrefix={'/landing'}
                    />

                    <h1 className={css.pageTitle}>{heading1}</h1>
                    <p className={css.pageTitleSubText}>{heading1_subText}</p>
                    <div className={css.headerMapWrapper}>
                        <div className={css.coverWrapper}>
                            <div className={css.findPlacesNearby}>
                                <h2 className={css.coverTitle}>{findPlacesNearbyTitle}</h2>
                                <p className={css.coverSubTitle}>{findPlacesNearbySubTitle}</p>
                                <div className={css.dumbInputRoot}>
                                    <input
                                        type="text"
                                        className={css.dumbInput}
                                        placeholder={findPlacesNearbyPlaceholder}
                                        onFocus={() =>
                                            redirectToURLWithModalState(
                                                { location, history },
                                                isMobile ? 'mobilesearch' : 'desktopsearch',
                                            )
                                        }
                                    />
                                    <div className={css.dumbFieldIconHolder}>
                                        <MagnifyIcon />
                                    </div>
                                </div>
                                <div className={css.reviewsIframe}>
                                    <iframe name="text-banner-widget_frame"
                                            id="text-banner-widget_frame"
                                            frameBorder="0" width="100%" scrolling="no" height="66"
                                            title="Reviews Widget"
                                            src="https://widget.reviews.io/rich-snippet-reviews-widgets/widget?version=13b&amp;store=www.horsedeal.com&amp;starsClr=%23faba05&amp;textClr=%231a2b49&amp;logoClr=white&amp;widgetName=text-banner&amp;translateOurCustomersSay=%20&amp;translateOutOf5BasedOn=bei&amp;translateReviews=Bewertungen&amp;translateExcellent=Hervorragend&amp;css=.TextBanner%20.ReviewsLogo%20%7B%20display%3A%20none%20%7D&amp;elementId=text-banner-widget&amp"></iframe>
                                </div>
                            </div>

                            <div id="text-banner-widget"
                                 style={{ maxWidth: 0, maxHeight: 0, transform: 'scale(0)' }} />
                            <div id="text-banner-widget-mobile"
                                 style={{ maxWidth: 0, maxHeight: 0, transform: 'scale(0)' }} />
                            <div className={css.coverImageWrapper}>
                                <img className={css.coverImage} src={mapUrl}   alt={altText} />
                            </div>
                        </div>
                        <div className={css.coverWrapper}>
                            {headerSubtitleMoreOffers && <div className={css.moreOffers}>
                                <div
                                    className={css.coverWrapperSubTitle}>{headerSubtitleMoreOffers}</div>
                                <ul className={css.moreOffersList}>
                                    <li><a
                                        href={location.pathname.replace('/spazierbeteiligung-finden/', '/reitbeteiligung-finden/')}>{intl.formatMessage({ id: 'SeoLandingPages.ridingShare.Name' })}</a>
                                    </li>
                                    <li><a
                                        href={location.pathname.replace('/spazierbeteiligung-finden/', '/pflegebeteiligung-finden/')}>{intl.formatMessage({ id: 'SeoLandingPages.careShare.Name' })}</a>
                                    </li>
                                </ul>
                            </div>}
                            {headerSubtitle && headerSubtext &&
                                <div className={css.locationInformation}>
                                    <div className={css.coverWrapperSubTitle}>{headerSubtitle}</div>
                                    <p className={css.coverWrapperSubText}>{headerSubtext}</p>
                                </div>}
                        </div>
                    </div>

                    <h2 className={css.pageHeading2}>{heading2}</h2>
                    <p>{heading2_subText}</p>

                    {generateListingContent(listingData, daysArray)}

                    <HorseDealCreateAccountTeaser
                        title={intl.formatMessage({ id: 'SeoLandingPages.walkingShare.AccountTeaserTitle' })}
                        participationName={intl.formatMessage({ id: 'SeoLandingPages.walkingShare.AccountTeaserParticipationName' })}
                        currentUser={currentUser}
                        address={popularDisciplinesAddress}
                        bounds={boundaries}
                        origin={loc}
                        listingType={listingTypeHorse}
                        pub_activities={pub_activities}
                    />

                    <ReviewsWidget className={css.reviewsioCarouselWidget} name={metaTitle} />

                    {!!listOfLocations?.data && (
                        <div className={css.sectionWrapper}>
                            <h2>{listOfLocationsHeading}</h2>
                            <p>{listOfLocations_subText}</p>
                            <AccordionItems
                               items={listOfLocations.data}
                                urlPrefix={`${listingsParticipationLinkPrefix}/${canton}`}
                                expandFirstElement={true}
                                prefix={intl.formatMessage({ id: 'SeoLandingPages.walkingShare.AccordionItems.Prefix' })}
                            />
                        </div>
                    )}

                    {city && <div className={css.sectionWrapper}>
                        <h2>{popularDisciplinesHeading}</h2>
                        <p>{popularDisciplinesSubText}</p>
                        <PopularDisciplines
                            participationName={intl.formatMessage({ id: 'SeoLandingPages.walkingShare.Name' })}
                            location={popularDisciplinesLocation}
                            address={popularDisciplinesAddress}
                            bounds={boundaries}
                            loc={loc}
                            listingType={listingTypeHorse}
                            pub_activities={pub_activities}
                        />
                    </div>}

                    {/*<div className={css.sectionWrapper}>*/}
                    {/*    <h2>{ridingDisciplinesLevelsTitle}</h2>*/}
                    {/*    <p>{ridingDisciplinesLevelsSubTitle}</p>*/}
                    {/*    <RidingDisciplinesLevels*/}
                    {/*        address={popularDisciplinesAddress}*/}
                    {/*        bounds={boundaries}*/}
                    {/*    />*/}
                    {/*</div>*/}

                    {listingsParticipationHeading && listingsParticipationSubText && (
                        <div className={css.sectionWrapperTop}>
                            <h2>{listingsParticipationHeading}</h2>
                            <p>{listingsParticipationSubText}</p>
                            <LandingpageListingsParticipation
                                titlePrefix={intl.formatMessage({ id: 'SeoLandingPages.walkingShare.Name' })}
                                urlPrefix={listingsParticipationLinkPrefix}
                                data={listingsParticipationData.data}
                            />
                        </div>
                    )}

                    <HorseDealAppTeaser />

                </LayoutWrapperMain>

                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

SpazierbeteiligungFindenPageDynamicComponent.propTypes = {
    currentUser: propTypes.currentUser,
    intl: intlShape.isRequired,
};

const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
});

const SpazierbeteiligungFindenPageDynamic = compose(
    connect(mapStateToProps),
    withRouter,
    injectIntl
)(SpazierbeteiligungFindenPageDynamicComponent);

SpazierbeteiligungFindenPageDynamic.loadData = loadWalkingParticipationData;

export default SpazierbeteiligungFindenPageDynamic;
